module.exports = __webpack_public_path__ + "static/media/discover.acb2f470.svg";